/* eslint-disable no-unused-vars */
import { errorActions } from "Features/error";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { api } from "Shared/axios";
import { getReqHeader } from "Shared/helpers";
import { selectWithdraw } from "Shared/store/withdraw";
import { walletsActions } from "./wallets.slice";

function* getWallets({ payload }) {
	const headers = yield call(getReqHeader);
	try {
		const { data } = yield call(api.get, `/wallet/${payload}`, headers);
		yield put(walletsActions.set(data));
	} catch (error) {
		console.error(error);
		yield put(walletsActions.set([]));
	}
}

function* addWallet({ payload }) {
	const { method, data: params } = yield payload;
	const headers = yield call(getReqHeader);
	try {
		yield call(api.post, `/wallet/${method}`, params, headers);
		yield put(walletsActions.get(method));
		yield put(walletsActions.addRes(true));
	} catch (error) {
		yield put(errorActions.addError({ page: "add_wallet", error }));
		yield put(walletsActions.addRes(false));
	}
}

function* deleteWallet({ payload: id }) {
	try {
		const headers = yield call(getReqHeader);
		const method = yield select(selectWithdraw.method);

		yield call(api.delete, `/wallet/${method}/${id}`, headers);
		yield put(walletsActions.get(method));
	} catch (error) {
		console.error(error);
	}
}

export function* watchWallets() {
	yield takeEvery(walletsActions.get, getWallets);
	yield takeEvery(walletsActions.addReq, addWallet);
	yield takeEvery(walletsActions.deleteWallet, deleteWallet);
}
